<template>
  <div>
    <div class="layer-page">
      <div>
        <clip-loader v-if="siteLoading || translateLoading" :color="'#2e8be8'" size="50px" class="clip-loader"></clip-loader>
        <div class="langSelectionSection" v-if="!siteLoading && !dataLoading" >
          <label class="excludeTranslation">Select Language</label>
          <select name="langSelector" v-model="selectedLang" @change="langChange($event)">
            <option class="excludeTranslation" value="en">English</option>
            <option class="excludeTranslation" value="es">Spanish</option>
            <option class="excludeTranslation" value="am">Amharic</option>
            <option class="excludeTranslation" value="ar">Arabic</option>
            <option class="excludeTranslation" value="mn">Mongolian</option>
          </select>
        </div>
        <div class="topParagraphText">
          <div v-if="paragraphLoaded" v-html="siteText"></div>
        </div>
        <br/>

        <br/>
        <div v-if="translatedSection" v-html="translatedSection"></div>
        <div v-if="!translatedSection" style="background-color: #f3f3f3;" class="fixedElement">
          <div style="float:left;margin-right:20px;">
            <label>Title</label>
            <input type=text size=25 v-model="fTitle" placeholder="Search by Camp Title">
          </div>
          <div style="float:left;margin-right:20px;">
            <label>Category</label>
            <select v-model="fCategory" id="filterDropdown">
              <option v-bind:value="'0'">--All--</option>
              <option v-for="category in categories" v-bind:key="category" v-bind:value="category">{{category}}</option>
            </select>
          </div>
          <div style="float:left;margin-right:20px;">
            <label>Location</label>
            <select v-model="fLocation" id="filterDropdown">
              <option v-bind:value="'0'">--All--</option>
              <option v-for="location in locations" v-bind:key="location" v-bind:value="location">{{location}}</option>
            </select>
          </div>
          <div style="float:left;margin-right:20px;">
            <label>Age</label>
            <select v-model="fAge">
              <option v-bind:value="'0'">--All--</option>
              <option v-for="age in ageRanges" v-bind:key="age" v-bind:value="age">{{age}}</option>
            </select>
          </div>
          <div style="float:left;margin-right:20px;">
            <label>Start Date</label>
            <select v-model="fDate">
              <option v-bind:value="'0'">--All--</option>
              <option v-for="startDate in startDates" v-bind:key="startDate" v-bind:value="startDate">{{startDate}}</option>
            </select>
          </div>
           <div style="float:left;margin-right:20px;">
            <label>Availability</label>
            <select v-model="fWaitList">
              <option v-for="wait in waitList" v-bind:key="wait" v-bind:value="wait">{{wait}}</option>
            </select>
          </div>
          <div style="float:right;margin-right:20px;">
            <button v-on:click="clearFilters()">Reset</button>
          </div>
        <br style="clear:both;" /><br/>
        </div>
        <br/>

        <clip-loader v-if="translateLoading" :color="'#2e8be8'" size="50px" class="clip-loader"></clip-loader>

        <v-client-table ref="campTable" :data="filteredCamps" :columns="columns" :options="options">
          <div slot="Official Title" slot-scope="props" id="camp-title"> <a v-if="props.row['Registration Website'].length > 7" target="_blank" :href="props.row['Registration Website']">{{props.row['Official Title']}}</a></div>
          <div slot="Activity Code" slot-scope="props" id="camp-activitycode">{{ props.row['activityCode'] }}</div>
          <div slot="Camp Description" slot-scope="props" id="camp-description">{{props.row['Camp Description']}}</div>
          <div slot="Provider" slot-scope="props" >
            <span v-if="props.row['Camp Type'] === 'DPR'" class='internal' v-tooltip.bottom="'This is an internal program'">{{props.row['Camp Type']}}</span>
            <span v-if="props.row['Camp Type'] !== 'DPR'">{{props.row['Camp Type']}}</span>
          </div>
          <div slot="Core Fee" slot-scope="props">
            <span v-if="props.row['Core Fee']">${{props.row['Core Fee']}}</span>
          </div>
          <div slot="Category" slot-scope="props">
            <span v-if="props.row['Category']">{{props.row['Translated Category'] || props.row['Category']}}</span>
          </div>
          <div slot="Enrolled" slot-scope="props">
            <span>{{!props.row['overallEnrollmentCnt'] ? 'n/a' : props.row['overallEnrollmentCnt']}}</span>
          </div>
          <div slot="Wait List" slot-scope="props">
            <span>{{props.row['waitListCnt']}}</span>
          </div>
          <div slot="Registration Website" slot-scope="props" >
            <div v-if="props.row['Registration Website']">
              <a v-if="props.row['Registration Website'].length > 7" target="_blank" :href="props.row['Registration Website']">Website</a>
              <span v-if="props.row['Registration Website'].length <= 7"></span>
            </div>
          </div>
        </v-client-table>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VTooltip from 'v-tooltip'
import { ClientTable } from 'vue-tables-2'
import _ from 'lodash'
import { GoogleTranslator } from '@translate-tools/core/translators/GoogleTranslator'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

Vue.use(VTooltip)
Vue.use(ClientTable)

const translator = new GoogleTranslator()

export default {
  name: 'Camps',
  components: {
		"clip-loader": ClipLoader
	},
  data () {
    return {
      fTitle: '',
      fCategory: '0',
      fLocation: '0',
      fAge: '0',
      fDate: '0',
      fWaitList: 'Any',
      availableNowInd: true,
      tooltip: 'this is an internal',
      engParagraphText: null,
      paragraphText: null,
      selectedLang: 'en',
      engFixedElementSection: null,
      engLabels: null,
      engOptions: null,
      translatedSection: null,

      columns: ['Official Title', 'Activity Code', 'Camp Description', 'Age Range', 'Location', 'Provider', 'Core Fee', 'Category', 'Date Range', 'Core Camp Time', 'Extended Hours', 'Enrolled', 'Wait List'],
      options: {
        headings: {
          'Official Title': 'Camp Title (Click to Register)'
        },
        sortable: ['Official Title'],
        perPage: 10,
        perPageValues: [10, 100, 5000],
        filterable: false
      },
      waitList: ['---All---','Available Now','Short Waitlist', 'Long Waitlist', 'External Provider']
    }
  },
  mounted: function () {
    this.getCamps()
    this.getSiteText()
    if (Object.keys(this.$route.query).length !== 0) {
      var self = this
      this.selectedLang = self.$route.query.lang
      setTimeout(() => {
        let v = {
          target: {
            value: self.$route.query.lang
          }
        }
        self.langChange(v)
      }, 2000);
    }
    setTimeout(() => {
      this.$refs.campTable.setLoadingState(true)
    }, 1500);
    VTooltip.options.disposeTimeout = 100
  },
  methods: {
    ...mapActions({
      getCamps: 'getCamps',
      translateCamps: 'translateCamps',
      getSiteText: 'getSiteText'
    }),
    clearFilters: function () {
      this.fTitle = ''
      this.fCategory = '0'
      this.fLocation = '0'
      this.fSession = '0'
      this.fAge = '0'
      this.fDate = '0',
      this.availableNowInd = true,
      this.fWaitList= '---All---'
    },
    async setPageText(selector, item, lang ) {
      let selectorHTML = document.querySelectorAll(`${selector}:not(.excludeTranslation)`)
      let innerText = Array.from(selectorHTML, e => e.innerText)
      if(!this[`eng${item}`]) {
        this[`eng${item}`] = innerText
      }
      let translatedText = this[`eng${item}`]
      if(lang) {
        translatedText = await translator.translateBatch(this[`eng${item}`], 'en', lang)
      }
      for (let i = 0; i < selectorHTML.length; i++) {
        selectorHTML[i].innerText = translatedText[i]
      }
    },
    async translateTextOnPage(lang) {
      if(lang == 'en') {
        this.setPageText('label', 'Labels')
        this.setPageText('option', 'Options')
      }
      else {
        this.setPageText('label', 'Labels', lang)
        this.setPageText('option', 'Options', lang)
      }
    },
    langChange(val) {
      this.translateTextOnPage(val.target.value);
      this.translateCamps(val.target.value)
    }
  },
  computed: {
    ...mapGetters(['camps', 'campTypes', 'ageRanges', 'locations', 'categories', 'startDates', 'siteText', 'siteLoading', 'dataLoading', 'translateLoading']),
    paragraphLoaded() {
      if (this.siteText) {

        // load initial paragraph for querying later
        if(this.engParagraphText == null) {
          let paragraphTextPos = this.siteText.indexOf("paragraphText")
          let paragraphTextStartPos = this.siteText.indexOf('>', paragraphTextPos) + 1
          let paragraphTextEndPos = this.siteText.indexOf('<', paragraphTextStartPos)
          let initialParagraph = this.siteText.substring(paragraphTextStartPos, paragraphTextEndPos)
          this.engParagraphText = initialParagraph
          this.paragraphText = initialParagraph
        }
      }
      return this.siteText != null
    },
    filteredCamps: function () {

      let filterData = this.camps

      filterData = this.fDate !== '0' ? _.filter(filterData, (item) => {
        return _.startsWith(item['Date Range'], this.fDate)
      }) : filterData

      filterData = this.fCategory !== '0' ? _.filter(filterData, {'Category': this.fCategory}) : filterData
      filterData = this.fLocation !== '0' ? _.filter(filterData, {'Location': this.fLocation}) : filterData

      filterData = this.fAge !== '0' ? _.filter(filterData, (item) => {
        let startAge = parseInt(item['Age Range'].substring(0, item['Age Range'].indexOf('-')))
        let endAge = parseInt(item['Age Range'].substring(item['Age Range'].indexOf('-') + 1))
        if (this.fAge === 'All Ages') {
          return item['Age Range'] === 'All Ages'
        } else {
          return startAge <= this.fAge && endAge >= this.fAge
        }
      }) : filterData

      let _title = this.fTitle.length > 0 ? this.fTitle.toLocaleLowerCase() : null

      filterData = _title ? filterData.filter((camps) => camps['Official Title'].toLocaleLowerCase().indexOf(_title) !== -1) : filterData

  //    filterData = this.availableNowInd ? filterData.filter(camps => camps['availableNowInd'] == true) : filterData.filter(camps => camps['availableNowInd'] == false)

      filterData = this.fWaitList == '--All--' ? filterData : ((this.fWaitList == 'Long Waitlist' ? filterData.filter(camps => camps['longWaitlistInd'] == true) : this.fWaitList == 'Short Waitlist' ? filterData.filter(camps => camps['shortWaitlistInd'] == true): this.fWaitList == 'Available Now' ? filterData.filter(camps => camps['availableNowInd'] == true): this.fWaitList == 'External Provider'? filterData.filter(camps => !camps['inRectracInd']) : filterData))
      var table = this.$refs.campTable
      if (table) {
        table.setPage(1)
      }

      return filterData
    }
  }
}
</script>

<style lang="scss">

  #camp-description {
    min-height: 50px;
    max-height: 150px;
    height:auto;
    overflow-y: auto;
    overflow-x: hidden;
  }

  tr th {
    background-color: #2e8be8;
    color: #fff;
    font-size: 1.5em;
    font-weight: 700;
    padding: 5px;
  }

  tr:first-child {
    background-color: #ebebeb;
    color: #000;
  }

  tr:first-child td {
    font-weight: normal;
    font-size: 1.3em;
  }

  td:nth-child(3) {
    // text-align:center;
    min-height: 50px;
    max-height: 75px;
    max-width: 300px;
    min-width: 300px;
    height:auto;
    overflow-y: auto;
    overflow-x: hidden;
  }

  nav a {
    display: inline;
  }
  nav .page-link {
    color: #000;
  }
  nav ul {
    overflow: hidden;
  }
  .langSelectionSection {
    position: absolute;
    top: 55px;
    right: 10%;
  }
  tr {
    th {
      text-align: left;
      padding-left: 10px
    }
  }
  ul {
    display: inline;
    list-style: none;
    li {
      font-size: 13px;
    }
  }
  ul.pagination {
    display:flex;
    list-style:none;
    color: #000;
    justify-content: flex-end;
  }

  li {
    margin-left: 1em;
    padding-left: 1em;
    text-indent: -1em;
    list-style-type: disc;
  }

  .VuePagination__pagination-item {
    margin: 5px;
    text-align: right;
  }
  .VuePagination {
    text-align: right;
    width: 1280px;
  }
  .VuePagination__pagination {
    margin-top:5px;
  }

  #filterDropdown {
    width: 200px;
  }

  input, label {
    display:block;
  }

  label {
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 1.3em;
    color: #666;
  }

  .internal {
    color: red;
    font-weight: bold;
  }

  .tooltip {
    display: block !important;

    .tooltip-inner {
      background: black;
      color: white;
      border-radius: 16px;
      padding: 5px 10px 4px;
    }
  }

.clip-loader {
	left: 50%;
	right: 50%;
	bottom: 60%;
	top: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/camps/camps.vue